import Vue from 'vue'
import moment from 'moment'

function getLocale() {
    return Vue.prototype._i18n.locale
}

Vue.filter('formatDate', function(value, format = 'DD/MM/YYYY HH:mm') {
    if (value) {
        let localeVar = getLocale()
        return moment(String(value)).locale(localeVar).format(format)
    }
})

Vue.filter('dateRangeHumanReadable', function(start, end, filtersTranslations) {

    let translations = {
        from: Vue.prototype.$t('filters.from'),
        to: Vue.prototype.$t('filters.to'),
        starting: Vue.prototype.$t('filters.starting'),
        ending: Vue.prototype.$t('filters.to')
    }

    if(filtersTranslations) {
        translations = filtersTranslations
    }

    // Parse dates
    let localeVar = getLocale()
    start = moment(start).locale(localeVar);
    end = moment(end).locale(localeVar);

    // What to display ?
    var displayTime = true;
    var displayEndDate = true;

    if (start.format('HH:mm') === '00:00') {
        displayTime = false;
    }

    if (start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
        displayEndDate = false;
    }

    // Define format
    if (displayEndDate && displayTime) {
        return translations.from + ' ' + start.format('ddd DD/MM HH:mm') + ' ' + translations.to + ' ' + end.format('ddd DD/MM HH:mm');
    }
    else if (displayEndDate) {
        return translations.from + ' ' + start.format('ddd DD/MM') + ' ' + translations.to + ' ' + end.format('ddd DD/MM');
    }
    else if (displayTime) {
        return start.format('dddd, Do MMMM YYYY') + ' ' + translations.starting + ' ' + start.format('HH:mm') + ' ' + translations.ending + ' ' + end.format('HH:mm');
    }
    else {
        return start.format('ddd DD/MM');
    }

})

Vue.filter('timeAgo', function(value) {
    if (value) {
        let localeVar = getLocale()
        return moment(String(value)).locale(localeVar).fromNow();
    }
})